import { createActionTypeModel } from "../../store/global/action-model";
import { PluginsService } from "./plugins.service";

export const getModulePluginStore = (modulePluginActionKey = 'BOOKING_PLUGINS', {
  storeNamespace = 'BookingStoreNamespace',
  plugins_section = 'Booking',
}) => {
  const ModulePluginAction = createActionTypeModel(modulePluginActionKey);

  return {
    storeNamespace,
    plugins_section,
    ModulePluginAction,
    actions: {
      async [ModulePluginAction.FETCH.ALL]({ commit, getters }, payload) {
        // console.log("Log: payload", payload)
        const { plugins_section } = payload;

        const pluginsData = await PluginsService.findAll({
          plugins_section
        });
        commit(ModulePluginAction.SET.ALL, pluginsData.data);
      }
    },
    mutations: {
      [ModulePluginAction.SET.ALL](state, payload) {
        state.pluginsData = payload;
      }
    },
    getters: {
      pluginsData: state => state.pluginsData
    },
    state: {
      pluginsData: null,
      add_button: `<button
@click="onClickBandCamp"
style="min-width: 150px"
class="dt-button v5 s8"
>
<template v-if="loadingGif">
<img src="static/icons/loading.gif" />
</template>
<template v-else>{{
'GET BANDCAMP ORDERS'
}}</template>
</button>`

    }
  };
}